if (!customElements.get('wls-predictive-search')) {
  class WLSPredictiveSearch extends WLSSearchForm {
    constructor() {
      super();
      this.classes = {
        active: 'active',
        hidden: 'hidden',
        results: 'js-wls-predictive-search-results',
        dropdown: 'js-predictive-search-dropdown',
        searchForm: 'wls-search-form',
      };
      this.selectors = {
        results: this.querySelector(`.${this.classes.results}`),
        dropdown: this.querySelector(`.${this.classes.dropdown}`),
        wlsSearchForm: this.querySelector(`${this.classes.searchForm}`),
      };
      this.cachedResults = {};
      this.abortController = new AbortController();
      this.searchTerm = '';
      this.isOpen = false;
      this.states = {
        isOpen: false,
        isLoading: false,
        isError: false,
      };
      this.boundPredictiveSearchCloseHandler = this.handlePredictiveSearchClose.bind(this);
      this.setupEventListeners();
    }

    connectedCallback() {
      this.setupEventListeners();
      this.addEventListener('wls:predictive-search:close', this.boundPredictiveSearchCloseHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('wls:predictive-search:close', this.boundPredictiveSearchCloseHandler);
    }

    setupEventListeners() {
      this.input.addEventListener('input', debounce(this.onInput.bind(this), 300));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.resetButton.addEventListener('click', this.closeResults.bind(this));
      document.addEventListener('mousedown', this.onDocumentClick.bind(this));
    }

    getQuery() {
      return this.input.value.trim();
    }

    onInput() {
      const query = this.getQuery();
      this.searchTerm = query;
      if (!query) {
        this.closeResults();
        return;
      }
      if (this.cachedResults[query]) {
        this.renderResults(this.cachedResults[query]);
        return;
      }
      this.fetchResults(query);
    }

    onFocus() {
      if (this.searchTerm && this.cachedResults[this.searchTerm]) {
        this.renderResults(this.cachedResults[this.searchTerm]);
      }
    }

    onKeydown(e) {
      if (!this.isOpen) return;
      const items = this.selectors.results.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
      if (!items.length) return;
      const active = document.activeElement;
      let idx = Array.from(items).indexOf(active);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        idx = (idx + 1) % items.length;
        items[idx].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        idx = (idx - 1 + items.length) % items.length;
        items[idx].focus();
      } else if (e.key === 'Escape') {
        this.closeResults();
        this.removeLoading();
        this.input.blur();
      }
    }

    onFormSubmit(e) {
      if (!this.getQuery()) {
        e.preventDefault();
        return;
      }
      this.closeResults();
    }

    onDocumentClick(e) {
      if (!this.contains(e.target)) {
        this.closeResults();
      }
    }

    fetchResults(query) {
      this.setLoading();
      fetch(`/search/suggest?q=${encodeURIComponent(query)}&section_id=wls-predictive-search`, {
        signal: this.abortController.signal,
      })
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const html =
            new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-wls-predictive-search')
              ?.innerHTML || '';
          this.cachedResults[query] = html;
          if (this.searchTerm === query) {
            this.renderResults(html);
          }
          this.removeLoading();
        })
        .catch(() => {
          this.renderResults('<div class="wls-search-form__error">Error loading results</div>');
          this.removeLoading();
        })
        .finally(() => {
          this.openResults();
        });
    }

    setLoading() {
      this.states.isLoading = true;
      this.selectors.wlsSearchForm.setLoading();
    }

    removeLoading() {
      this.states.isLoading = false;
      this.selectors.wlsSearchForm.removeLoading();
    }

    renderResults(html) {
      this.selectors.results.innerHTML = html;
      this.openResults();
      this.states.isOpen = true;
    }

    openResults() {
      this.selectors.dropdown.classList.add(this.classes.active);
      this.states.isOpen = true;
    }

    closeResults() {
      this.selectors.dropdown.classList.remove(this.classes.active);
      this.selectors.results.innerHTML = '';
      this.states.isOpen = false;
    }

    handlePredictiveSearchClose() {
      this.closeResults();
      this.removeLoading();
    }
  }
  customElements.define('wls-predictive-search', WLSPredictiveSearch);
}
